// Mirrors backend `models.IMPORT_STUB_SOURCES`: every provenance that means
// "a placeholder nobody has reviewed yet" rather than a family an instructor
// added. A roster bulk-imported by an organization is one of them — a school's
// list of names is not a family who has answered anything.
export const IMPORT_STUB_SOURCES = ['acuity_import', 'scheduler_import', 'org_roster_import'];

// Mirrors backend `services/program_roster_privacy.PROGRAM_ROSTER_SOURCES`:
// a student an organization put on a program's class roster. The
// organization keeps their details and their consent, so the instructor's
// portal shows them as "Maya R." (shortened by the server), offers no
// consent request, and edits only instruments and notes.
export const PROGRAM_ROSTER_SOURCES = ['org_roster_import', 'org_class_roster'];

export const isProgramRosterStudent = (student) =>
  student?.program_roster === true || PROGRAM_ROSTER_SOURCES.includes(student?.source);

// Not a program's student: the "needs review" prompts ask the instructor to
// add the very details a program's roster keeps from them.
export const isImportedStub = (student) =>
  IMPORT_STUB_SOURCES.includes(student?.source) && !student?.age_band && !isProgramRosterStudent(student);
export const realStudentEmail = (email) => email && !email.toLowerCase().endsWith('@acuity-import.lab401.ai') ? email : '';

// A scheduling booker/signer's contact is not a student or portal recipient.
// Preserve the explicit legacy Acuity review flow while suppressing placeholders
// even after a booking consent receipt has supplied the student's age band.
export function studentContactEmail(student) {
  if (student?.source === 'acuity_import' && isImportedStub(student)) return student.acuity_booker_email || '';
  return realStudentEmail(student?.email);
}
